import React from 'react';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Values } from './components/Values';
import { Project } from './components/Project';
import { Timeline } from './components/Timeline';
import { Footer } from './components/Footer';
import { LanguageProvider } from './i18n/LanguageContext';
import { LanguageSwitcher } from './components/LanguageSwitcher';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-bg-primary text-white selection:bg-gold selection:text-bg-primary" data-id="element-1">
        <LanguageSwitcher data-id="element-2" />
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Values data-id="element-5" />
        <Project data-id="element-6" />
        <Timeline data-id="element-7" />
        <Footer data-id="element-8" />
      </div>
    </LanguageProvider>;
}